import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Card } from '@node-space/ui-components'
import { EarnSummaryItem, EarnSummaryItemVariant } from '../EarnSummaryItem'

export interface EarnDirectSummaryProps {
  allocatedFunds: string
  availableFunds: string
  totalAllTimeEarnings?: string
  isStatisticsLoading?: boolean
}

export const EarnDirectSummary = ({
  allocatedFunds,
  availableFunds,
  totalAllTimeEarnings,
  isStatisticsLoading,
}: EarnDirectSummaryProps) => {
  const { t } = useTranslation()

  return (
    <Card
      variant="static"
      full
      borderRadius={12}
      testId="earn-summary"
      className="bg-surface-interactive"
    >
      <Box flex gap={24} align="center" className="max-sm:flex-col max-sm:items-start">
        <EarnSummaryItem
          label={t('earn.myAllocatedFunds')}
          value={allocatedFunds}
          variant={EarnSummaryItemVariant.LARGE}
          tooltipContent={t('earn.myAllocatedFundsTooltip')}
        />
        <EarnSummaryItem
          label={t('earn.myUnallocatedFunds')}
          value={availableFunds}
          variant={EarnSummaryItemVariant.LARGE}
          isLoading={isStatisticsLoading}
          testId="earn-available-funds"
          tooltipContent={t('earn.myUnallocatedFundsTooltip')}
        />

        {totalAllTimeEarnings && (
          <EarnSummaryItem
            label={t('earn.totalAllTimeEarnings')}
            value={totalAllTimeEarnings}
            variant={EarnSummaryItemVariant.LARGE}
          />
        )}
      </Box>
    </Card>
  )
}
